import Swal from "sweetalert2";

export function showSpinnerCustom(title, text) {
  Swal.fire({
    title: title,
    html: text,
    timerProgressBar: true,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

export function showMessageCustom(title, text, onOk) {
  Swal.fire({
    title: title,
    html: text,
    confirmButtonText: "OK",
  }).then((result) => {
    if (result.isConfirmed && typeof onOk === "function") {
      onOk(); // Execute the provided callback function
    }
  });
}

export function messageConfimation(title, text, onOk, onCancel) {
  Swal.fire({
    title: `<strong style="font-size:20px;">${title}</strong>`,
    html: `<p class="swal-subtitle">${text}</p>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Submit",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#28a745", // Green for Submit
    cancelButtonColor: "#dc3545", // Red for Cancel
    reverseButtons: true,
    customClass: {
      title: "swal-title-center",
      confirmButton: "swal-button-rounded",
      cancelButton: "swal-button-rounded",
    },
  }).then((result) => {
    if (result.isConfirmed && typeof onOk === "function") {
      onOk();
    } else if (result.isDismissed && typeof onCancel === "function") {
      onCancel();
    }
  });
}
